import { Task } from "@dhx/react-gantt";
import { SchedulingItem, SchedulingStatus } from "../types/scheduling";
import dayjs from "dayjs";

export const transformSchedulingItemToTask = (item: SchedulingItem): Task => {
  const type =
    item.type === "phase"
      ? "project"
      : item.type === "stage_gate"
      ? "milestone"
      : "task";

  let startDateRaw = item.planned_start_date;
  if (type === "milestone" && !startDateRaw && item.planned_end_date) {
    startDateRaw = item.planned_end_date;
  }

  const startDate = startDateRaw
    ? new Date(startDateRaw)
    : new Date();

  const endDate = item.planned_end_date
    ? new Date(item.planned_end_date)
    : new Date();

  const duration = Math.max(
    1,
    Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24))
  );

  const progress = parseFloat(item.progress_percentage) / 100 || 0;

  const task: Task = {
    id: item.id,
    text: item.name,
    type,
    start_date: startDate,
    duration,
    progress,
    parent: item.parent_id || 0,
    open: true,
  };

  // if (type === "milestone") {
  //   (task as any).readonly = true;
  // }

  return task;
};

export const transformSchedulingItemsToTasks = (
  items: SchedulingItem[]
): Task[] => {
  return items.map(transformSchedulingItemToTask);
};

export const getStatusFromProgress = (progress: number): SchedulingStatus => {
  if (progress === 0) return "not_started";
  if (progress === 100) return "completed";
  return "in_progress";
};

export const formatDateForAPI = (date: Date | string): string => {
  return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
};

export const calculateEndDate = (startDate: Date, duration: number): Date => {
  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + duration);
  return endDate;
};

export const calculateDuration = (startDate: Date, endDate: Date): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(1, diffDays);
};
